import { VideoStore } from '@/front/stores/video_store.js'

// Store initialization helper
function getStores() {
  return {
    videoStore: VideoStore(),
  }
}

/**
 * Track a click interaction
 */
export function getBaseButtonStyle(ann = null) {
  const { videoStore } = getStores()
  if (!videoStore.video.design) return {}
  const design = videoStore.video.design
  return {
    background: design.button_background_color,
    color: design.button_text_color,
    border: '0.2rem solid',
    borderColor: design.button_border_color,
    designbr: design.button_border_radius,
    borderRadius: ann ? 0.1 * ann.border_radius + 'rem' : 0.1 * design.button_border_radius + 'rem',
  }
}
